<template>
    <div :class="classes">
        <slot name="lt" />
		<div class="content">
			<slot />
		</div>
		<slot name="rt" />
    </div>
</template>
<script>
// 组件class前缀
const prefixCls = 'wt-list-item'
export default {
  name: 'wt-list-item',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  }

}
</script>
<style lang="less">
.wt-list-item {
	display: flex;
	flex-direction: row;
	position: relative;
	.wt-box + .wt-box {
		padding: 0 0.06rem;
	}
	> .content {
		flex: 1;
		display: flex;
		padding: 0 0.06rem;
	}
}
</style>
